export enum OrgPermission {
  MANAGE_ORGANIZATION = 'manage_organization',
  MANAGE_MEMBERS = 'manage_members',
  MANAGE_COUPLES = 'manage_couples',
  VIEW_COUPLES = 'view_couples',
  VIEW_ASSESSMENTS = 'view_assessments',
  VIEW_STATISTICS = 'view_statistics',
  CERTIFY_COUPLES = 'certify_couples',
  INVITE_COUPLES = 'invite_couples',
}

export const ALL_PERMISSIONS = Object.values(OrgPermission)

export function hasPermission(
  permissions: string[] | undefined | null,
  role: string | undefined | null,
  permission: OrgPermission
): boolean {
  if (role === 'super_admin' || role === 'organization_admin') return true
  return Array.isArray(permissions) && permissions.includes(permission)
}

export function hasAnyPermission(
  permissions: string[] | undefined | null,
  role: string | undefined | null,
  required: OrgPermission[]
): boolean {
  if (role === 'super_admin' || role === 'organization_admin') return true
  return required.some((p) => Array.isArray(permissions) && permissions.includes(p))
}
